import { PacketQueueCategory } from './../package/create-package-dialog/create-package-dialog.component';
export class Configuration{
    constructor(
        public PacketID: number,
        public GCAttribute: string,
        public GCAttributeValue: string,
        public GCAttributeCount: number,
        public GCSourceType: string
    ){}
};

export class SavedConfiguration{
    constructor(
        public ConfigId: number,
        public PacketId: number,
        public QualityAttribute: string,
        public QualityAttributeValue: string,
        public QualityAttributeCount: number,
        public SourceType: string
    ){}
};
export class PacketDetails{
    constructor(
        public ID: number,
        public Creation: Date,
        public Name: string,
        public QueueCategory: string,
        public IsActive: boolean,
        public GroupBy: string,
        public Status: string,
        public Priority: number,
        public Age: number,
        public IsCurrentTickets: boolean
    ){}
};

export class SystemSetting{
constructor(
    public ID: number,
    public Name: string,
    public Value: string,
    public Description: string
){}
};